import './styles.css';
import { mountShell } from './ui/shell';
import { mountMap } from './ui/map-view';
import { mountOnsite } from './ui/onsite-view';
import { mountMeasures } from './ui/measures-view';
import { loadAll } from './ui/data';

const shell = mountShell(document.getElementById('app')!);
mountMap(shell.outlet('mappa'));
mountOnsite(shell.outlet('posto'));
mountMeasures(shell.outlet('misure'));
void loadAll();

// Ask the browser not to evict local data (queued measurements, profiles) under storage pressure.
void navigator.storage?.persist?.().catch(() => undefined);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
